import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Ticket } from 'src/app/services/asignaciones.service';
import {
  gitlabMrTone,
  gitlabMrTooltip,
  primaryGitlabMergeRequest,
} from '../../utils/ticket-gitlab-mr.util';

@Component({
  selector: 'app-asignaciones-mr-icon',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './asignaciones-mr-icon.component.html',
  styleUrls: ['./asignaciones-mr-icon.component.scss'],
})
export class AsignacionesMrIconComponent {
  @Input({ required: true }) ticket!: Ticket;
  /** Si es false, solo muestra el estado (útil dentro de un botón). */
  @Input() clickable = true;

  get mr() {
    return primaryGitlabMergeRequest(this.ticket);
  }

  get tone() {
    return this.mr ? gitlabMrTone(this.mr.state) : null;
  }

  get tooltip() {
    return this.mr ? gitlabMrTooltip(this.mr) : '';
  }
}
